import Image, { ImageProps } from './Image';
export default Image;
export type { ImageProps };
